/**
 * Builds the "Add to email" mailto: link for the confirmation screen (confirmation/spec §3).
 * The tracking code is the ONLY way an anonymous reporter can check status later (ADR-0005), so
 * this lets them mail themselves a copy in one tap. Pure + exported so the string construction is
 * unit-testable; every interpolated value is percent-encoded (a code/URL never breaks the header).
 */
export interface MailtoParts {
  /** e.g. "City of Linn Valley" — used in the subject line. */
  townName: string;
  /** The tracking code exactly as issued (full string, not the display-formatted one). */
  trackingCode: string;
  /** The absolute …/track/<code> URL. */
  trackingUrl: string;
}

export function buildTrackingMailto({ townName, trackingCode, trackingUrl }: MailtoParts): string {
  const subject = `Your ${townName} concern — tracking code ${trackingCode}`;
  const body = [
    `Keep this so you can check your concern later.`,
    ``,
    `Tracking code: ${trackingCode}`,
    `Check status: ${trackingUrl}`,
    ``,
    `This code is the only way to look up an anonymous report — save it somewhere safe.`,
  ].join("\n");

  // mailto: with no recipient (the resident fills in their own address in their mail client).
  return `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
